import { render, staticRenderFns } from "./AppPageContainer.vue?vue&type=template&id=61fd7964&scoped=true"
import script from "./AppPageContainer.vue?vue&type=script&lang=js"
export * from "./AppPageContainer.vue?vue&type=script&lang=js"
import style0 from "./AppPageContainer.vue?vue&type=style&index=0&id=61fd7964&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fd7964",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCol,VContainer,VFadeTransition,VRow})
